class DefaultOption {
  data;

  icon;

  label;

  constructor(data, icon, label) {
    this.data = data;
    this.icon = icon;
    this.label = label;
  }

  async fetchDetails() {
    return this.data;
  }
}

export default DefaultOption;
